import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select, Table, Tag } from "antd";
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon, validateMessages } from '../../helpers/common';
import { layDanhSachTongHopTheoThang } from '../../services/ngoaigio';
import { DonNgoaiGio, TimKiemDonNgoaiGioRequest } from "../../models/ngoaigio/DonNgoaiGio";
import dayjs from "dayjs";

const DanhSachThemGioTongHop = () => {
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const menu: any = menuHelper.checkMultiPermission([Links.NgoaiGio.DangKy]);
    const [page, setPage] = useState(1);

    const [danhSach, setDanhSach] = useState<Array<DonNgoaiGio>>([]);
    const OPTIONS = [
        'Ngày tạo',
        'Ngày làm thêm giờ',
        'Từ khóa'
    ];

    const [selectedItems, setSelectedItems] = useState<any[]>(["Ngày tạo"]);

    const handleChange = (e: any, currentIndex: number) => {
        var temp = [...selectedItems];
        temp[currentIndex] = e;
        form.setFieldsValue({
            'tuKhoa': null,
            'ngayTaoTuNgay': null,
            'ngayTaoDenNgay': null,
            'ngayDangKyTuNgay': null,
            'ngayDangKyDenNgay': null,
        });
        setSelectedItems(temp);
    }
const [form] = Form.useForm();


    const timkiem = async (request: TimKiemDonNgoaiGioRequest) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await layDanhSachTongHopTheoThang(request);
            setDanhSach(temp.data);
            setIsLoadingTable(false);
        }
        catch (error: any) {
            toast.error(error);
            setIsLoadingTable(false);
        };
    }

    useEffect(() => {
        form.setFieldsValue({
            'ngayTaoTuNgay': ngayDauThang,
            'ngayTaoDenNgay': ngayCuoiThang,
            'tuKhoa': null,
            'ngayDangKyTuNgay': null,
            'ngayDangKyDenNgay': null,
        });
        var rq = new TimKiemDonNgoaiGioRequest;
        rq.ngayTaoTuNgay = ngayDauThang.toDate();
        rq.ngayTaoDenNgay = ngayCuoiThang.toDate();

        timkiem(rq);
    }, []);
    const ngayDauThang = dayjs().startOf('month');
    const ngayCuoiThang = dayjs().endOf('month');
    const renderInput = (item: any) => {
        switch (item) {
            case "Ngày tạo":
                return (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="ngayTaoTuNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Từ ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="ngayTaoDenNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Đến ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                );
            case "Ngày làm thêm giờ":
                return (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="ngayDangKyTuNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Từ ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="ngayDangKyDenNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Đến ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                );
            case "Từ khóa":
                return (<Form.Item name="tuKhoa">
                    <Input allowClear placeholder="--Nhập tên nhân viên, tên phòng ban, loại nghỉ phép--" />
                </Form.Item>);
        }
    }
    const onFinish = (values: any) => {
        var rq = new TimKiemDonNgoaiGioRequest;
        rq.ngayTaoTuNgay = values.ngayTaoTuNgay;
        rq.ngayTaoDenNgay = values.ngayTaoDenNgay;
        rq.ngayDangKyTuNgay = values.ngayDangKyTuNgay;
        rq.ngayDangKyDenNgay = values.ngayDangKyDenNgay;
        rq.tuKhoa = values.tuKhoa;
        timkiem(rq);
    }
    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            form.validateFields().then(async (values) => { onFinish(values); });
        }
    };


    return (
        <section>
            <ContentHeader title="Danh sách đơn thêm giờ" />
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
                onKeyPress={handleKeyPress}
            >
                <Row gutter={8} className="form-group">
                    <Col span={12}>
                        {selectedItems.map((item, index) => {
                            return <Row className="mb-2" gutter={8} key={index} style={{ width: '100%', height: '40px' }}>
                                <Col span="8">
                                    <Select
                                        placeholder="--Chọn trường--"
                                        value={item}
                                        onChange={(e) => handleChange(e, index)}
                                        style={{ width: '100%', height: '35px' }}
                                        options={OPTIONS.map((item) => ({
                                            value: item,
                                            label: item,
                                        }))}
                                        showSearch
                                        filterOption={function (search, item: any) {
                                            return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                                        }}
                                    />
                                </Col>
                                <Col span="16">
                                    {renderInput(item)}
                                </Col>
                            </Row>
                        })}
                    </Col>
                    <Col span={4}>
                        <Button type="primary" icon={<SearchOutlined rev="" />} htmlType='submit'>
                            Tìm kiếm
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={(danhSach || []).map((item: any, index) => { item.key = index; return item; })}
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            pagination={{
                                current: page,
                                onChange: (page, pageSize) => {
                                    setPage(page);
                                },
                            }}
                        >
                            <Column title="STT" key="STT" width="5%" render={(value, record, index) =>
                                (<span key={"stt" + index}> {(page - 1) * searchLength + index + 1}</span>)
                            } />
                            <Column title="Nhân viên" dataIndex="tenNhanVien" key="tenNhanVien" />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column title="Trạng thái" width="15%" dataIndex="trangThai" key="trangThai" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
                                    case 1: tag = (<Tag color="warning">Trình Lãnh đạo</Tag>); break;
                                    case 2: tag = (<Tag color="success">Đã Duyệt</Tag>); break;
                                    case 3: tag = (<Tag color="error">Từ chối</Tag>); break;
                                    case 4: tag = (<Tag color="error">Lấy ý kiến</Tag>); break;
                                }
                                return tag;
                            }} />
                            <Column title="Người ý kiến" dataIndex="tenNguoiYKien" key="tenNguoiYKien" />
                            <Column title="Người duyệt" dataIndex="tenNguoiDuyet" key="tenNguoiDuyet" />
                            <Column title="Ngày đăng ký" dataIndex="ngay" key="ngay" render={(value: any, record: any) => {
                                return dateCommon.formatDate(value, "dd/MM/yyyy");
                            }} />
                            <Column title="Số giờ" dataIndex="soGio" key="soGio" />
                            <Column title="Ngày tạo" dataIndex="ngayKhoiTao" key="ngayKhoiTao" render={(value: any, record: any) => {
                                return dateCommon.formatDate(value, "dd/MM/yyyy");
                            }} />
                            <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return menu[Links.NgoaiGio.DangKy]
                                    ? (<Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.NgoaiGio.Xem + "?id=" + record.id}>Xem</Link>)
                                    : "";
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachThemGioTongHop;